import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../../../api/axiosInstance';
import { token } from '../../../../utils/config';

export const loginUser = createAsyncThunk(
    'auth/loginUser',
    async (credentials, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post('/login', credentials);
            console.log('Login API response:', response.data);
            return response.data;
        } catch (error) {
            console.error('Login API error:', error);
            return rejectWithValue(error.response ? error.response.data : 'Network error');
        }
    }
);

const initialState = {
    user: JSON.parse(localStorage.getItem('crm-user')) || null,
    token: token || null,
    depositSummary: null,
    withdrawalSummary: null,
    tradeAccounts: [],
    status: 'idle',
    error: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logout: (state) => {
            state.user = null;
            state.token = null;
            state.depositSummary = null;
            state.withdrawalSummary = null;
            state.tradeAccounts = [];
            localStorage.removeItem('crm-user');
            localStorage.removeItem('token');
        },
        
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginUser.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(loginUser.fulfilled, (state, action) => {
                state.status = 'succeeded';
                console.log('login action payload', action.payload);
                
                const { access_token, user, dashboard, trade_accounts } = action.payload || {};

                if (access_token && user && dashboard && trade_accounts) {
                    state.user = user;
                    state.token = access_token;
                    state.depositSummary = dashboard?.deposits;
                    state.withdrawalSummary = dashboard?.withdrawals;
                    state.tradeAccounts = trade_accounts;

                    // Store essential data in localStorage
                    localStorage.setItem('crm-user', JSON.stringify(user));
                    localStorage.setItem('token', access_token);
                } else {
                    state.status = 'failed';
                    state.error = 'Unexpected API response structure';
                }
            })
            .addCase(loginUser.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'Login failed';
            });
    },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
